module.exports = __webpack_public_path__ + "static/media/TRAINING_EVENING.3491284b.jpg";